import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { API } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/signin", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        await refresh();
        // Clean hash, go to network
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/network", { replace: true });
      } catch (err) {
        navigate("/signin?error=auth_failed", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FFF8E7]" data-testid="auth-callback">
      <div className="text-center">
        <div className="text-sm uppercase tracking-[0.2em] font-bold text-[#1A5DFF] mb-3">Signing you in</div>
        <div className="font-heading text-3xl text-[#0A0A0A]">One moment…</div>
      </div>
    </div>
  );
}
